<template>
  <div class="card-form">
    <PageTable
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: { platformCode: { type: String, default: '' } },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.platformCode) return
      this.loading = true
      this.$api
        .ecomEvgPackingSchemeSkuOptionsApi({
          ...form,
          ...this.page,
          platformCode: this.platformCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
